// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"808":"b85b9b8f","920":"dd80bca5"}[chunkId] + ".chunk.js";
};